/* unplugin-vue-components disabled */import { render } from "./bindPermission.vue?vue&type=template&id=47207926&scoped=true"
import script from "./bindPermission.vue?vue&type=script&lang=js"
export * from "./bindPermission.vue?vue&type=script&lang=js"

import "./bindPermission.vue?vue&type=style&index=0&id=47207926&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/e-bike/e-bike-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47207926"]])

export default __exports__